import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52af70c2")

_pushScopeId("data-v-52af70c2")
const _hoisted_1 = {
  key: 0,
  class: "container all-documents"
}
const _hoisted_2 = { class: "documents-page-title" }
const _hoisted_3 = { class: "documents-search" }
const _hoisted_4 = { class: "documents-search-filter d-flex mt-auto" }
const _hoisted_5 = { class: "search-button-wrapper pl-15" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_7 = { class: "documents-search-total px-lg-3" }
const _hoisted_8 = { class: "show-all-clear-filter" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "documents-filter-circle"
}
const _hoisted_11 = { class: "documents-total" }
const _hoisted_12 = { class: "documents-export-wrapper pt-2 pt-lg-0 px-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-export fs-18" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "pt-2 pt-lg-0"
}
const _hoisted_15 = { class: "mobile-grid" }
const _hoisted_16 = { class: "w100" }
const _hoisted_17 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "table-text-setting" }
const _hoisted_20 = { class: "table-text-setting" }
const _hoisted_21 = { class: "customer-padding" }
const _hoisted_22 = { class: "table-text-setting" }
const _hoisted_23 = { class: "table-text-setting" }
const _hoisted_24 = { class: "table-text-setting" }
const _hoisted_25 = { class: "table-text-setting" }
const _hoisted_26 = { class: "table-text-setting" }
const _hoisted_27 = { class: "table-text-setting" }
const _hoisted_28 = { class: "table-text-setting" }
const _hoisted_29 = { class: "table-text-setting" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-ellipsis fs-16 ellipsis-icon" }, null, -1)
const _hoisted_31 = { class: "desktop-grid" }
const _hoisted_32 = { class: "w100" }
const _hoisted_33 = { class: "desktop-table-actions" }
const _hoisted_34 = { class: "thead-cell-center" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "desktop-table-text-setting" }
const _hoisted_37 = { class: "cuted-cell-one-line" }
const _hoisted_38 = { class: "desktop-table-text-setting" }
const _hoisted_39 = { class: "cuted-cell" }
const _hoisted_40 = { class: "desktop-table-text-setting" }
const _hoisted_41 = { class: "desktop-table-text-setting" }
const _hoisted_42 = { class: "desktop-table-text-setting" }
const _hoisted_43 = { class: "cuted-cell" }
const _hoisted_44 = { class: "desktop-table-text-setting" }
const _hoisted_45 = { class: "desktop-table-text-setting" }
const _hoisted_46 = { class: "cuted-cell-one-line" }
const _hoisted_47 = { class: "desktop-table-text-setting" }
const _hoisted_48 = { class: "cuted-cell-one-line" }
const _hoisted_49 = { class: "desktop-table-text-setting" }
const _hoisted_50 = { class: "cuted-cell" }
const _hoisted_51 = { class: "desktop-table-text-setting" }
const _hoisted_52 = { class: "cuted-cell-one-line" }
const _hoisted_53 = { class: "desktop-table-actions" }
const _hoisted_54 = {
  class: "mobile-documents-actions",
  id: "mobile-documents-actions"
}
const _hoisted_55 = { class: "mobile-documents-actions-buttons" }
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-share fs-26 ellipsis-icon" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-eye fs-26 ellipsis-icon" }, null, -1)
const _hoisted_58 = { class: "actions-documents-back-block" }
const _hoisted_59 = { class: "documents-sticky-summary-wrapper" }
const _hoisted_60 = { class: "documents-sticky-summary" }
const _hoisted_61 = { class: "documents-total" }
const _hoisted_62 = { class: "documents-total" }
const _hoisted_63 = { class: "documents-total" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.loaded)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('product.documents')), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _withDirectives(_createVNode("input", {
              class: "bookit-input order-input",
              id: "datetime",
              type: "text",
              placeholder: _ctx.$t('placeholder.searchByNumberTypeOrCustomerName'),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.keyword = $event))
            }, null, 8, ["placeholder"]), [
              [_vModelText, _ctx.filter.keyword]
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getDocumentsOnClick && _ctx.getDocumentsOnClick(...args)))
              }, [
                _hoisted_6
              ])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
              }, _toDisplayString(_ctx.$t('button.showAll')), 1)
            ]),
            _createVNode("div", {
              class: ["documents-filter", { hasFilter: _ctx.hasFilter }]
            }, [
              _createVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goFilter())),
                type: "button"
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
                _hoisted_9
              ]),
              (_ctx.hasFilter)
                ? (_openBlock(), _createBlock("div", _hoisted_10, "!"))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", null, _toDisplayString(_ctx.$t('documents.totalDocuments')) + ":", 1),
              _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " " + _toDisplayString(_ctx.$t('documents.ofDoc', { quantityOfDocuments: _ctx.total })), 1)
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("button", {
              class: "order-circle-btn report-export",
              type: "button",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exportDocuments && _ctx.exportDocuments(...args)))
            }, [
              _hoisted_13,
              _createVNode("div", null, _toDisplayString(_ctx.$t('report.export')), 1)
            ])
          ]),
          (_ctx.filter.orderId)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("button", {
                  class: "order-circle-btn new-order",
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.callUploadingFunction && _ctx.callUploadingFunction(...args)))
                }, [
                  _createVNode("input", {
                    type: "file",
                    name: "file-upload-input",
                    id: "file-upload-input",
                    style: {"display":"none"},
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.uploadingFileValidation && _ctx.uploadingFileValidation(...args)))
                  }, null, 32),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('documents.upload-new-doc')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("table", _hoisted_16, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("td", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sotrBy('Number')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.number')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Number')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sotrBy('Type')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.type')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Type')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sotrBy('Customer')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.customer')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Customer')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sotrBy('CreateDate')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.createDate')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CreateDate')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sotrBy('ValueDate')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.valueDate')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ValueDate')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sotrBy('User')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.user')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('User')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sotrBy('Total')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.amount')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Total')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sotrBy('AmountBeforeVat')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.amountBeforeVat')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('AmountBeforeVat')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sotrBy('Vat')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.vat')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Vat')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sotrBy('BusinessClientName')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('businessClients.name')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('BusinessClientName')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sotrBy('CurrencyName')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('title.currency')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CurrencyName')]
                    }, null, 2)
                  ])
                ]),
                _hoisted_17
              ])
            ]),
            (_ctx.documents && _ctx.documents.length)
              ? (_openBlock(), _createBlock("tbody", _hoisted_18, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documents, (doc) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: doc.documentNumber
                    }, [
                      _createVNode("td", {
                        class: "documentNumber",
                        onClick: ($event: any) => (_ctx.goToDetailsOfDoc(doc))
                      }, _toDisplayString(doc.documentNumber), 9, ["onClick"]),
                      _createVNode("td", _hoisted_19, _toDisplayString(doc.providerDocumentTypeName ?? _ctx.getDocumentType(doc)), 1),
                      _createVNode("td", _hoisted_20, [
                        _createVNode("div", _hoisted_21, _toDisplayString(doc.customer), 1)
                      ]),
                      _createVNode("td", _hoisted_22, _toDisplayString(_ctx.getDateToTitle(doc.createDate)), 1),
                      _createVNode("td", _hoisted_23, _toDisplayString(_ctx.getDateToTitle(doc.issueDate)), 1),
                      _createVNode("td", _hoisted_24, [
                        _createVNode("span", null, _toDisplayString(doc.creator), 1)
                      ]),
                      _createVNode("td", _hoisted_25, [
                        _createVNode("span", {
                          style: { color: _ctx.getColorOfAmount(doc) }
                        }, _toDisplayString(_ctx.formatAmount(doc.total)), 5)
                      ]),
                      _createVNode("td", _hoisted_26, [
                        _createVNode("span", null, _toDisplayString(_ctx.formatAmount(doc.amountBeforeVat)), 1)
                      ]),
                      _createVNode("td", _hoisted_27, [
                        _createVNode("span", null, _toDisplayString(_ctx.formatAmount(doc.vat)), 1)
                      ]),
                      _createVNode("td", _hoisted_28, [
                        _createVNode("span", null, _toDisplayString(doc.businessClientName), 1)
                      ]),
                      _createVNode("td", _hoisted_29, [
                        _createVNode("span", null, _toDisplayString(doc.currency), 1)
                      ]),
                      _createVNode("td", {
                        onClick: ($event: any) => (_ctx.showMobileActions(doc)),
                        class: "ellipsis-td"
                      }, [
                        _hoisted_30
                      ], 8, ["onClick"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_31, [
          _createVNode("table", _hoisted_32, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("td", {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sotrBy('Number')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.number')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Number')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sotrBy('Type')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.type')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Type')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sotrBy('Customer')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.customer')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Customer')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.sotrBy('CreateDate')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.createDate')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CreateDate')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.sotrBy('ValueDate')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.valueDate')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ValueDate')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.sotrBy('User')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.user')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('User')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.sotrBy('Total')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.amount')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Total')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.sotrBy('AmountBeforeVat')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.amountBeforeVat')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('AmountBeforeVat')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.sotrBy('Vat')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.vat')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Vat')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sotrBy('BusinessClientName')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('businessClients.name')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('BusinessClientName')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.sotrBy('CurrencyName')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('title.currency')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('CurrencyName')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", _hoisted_33, [
                  _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('customerType.actions')), 1)
                ])
              ])
            ]),
            (_ctx.documents && _ctx.documents.length)
              ? (_openBlock(), _createBlock("tbody", _hoisted_35, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documents, (doc, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", {
                        class: "documentNumber text-link",
                        onClick: ($event: any) => (_ctx.goToDetailsOfDoc(doc))
                      }, _toDisplayString(doc.documentNumber), 9, ["onClick"]),
                      _createVNode("td", _hoisted_36, [
                        _createVNode("span", _hoisted_37, _toDisplayString(doc.providerDocumentTypeName ?? _ctx.getDocumentType(doc)), 1)
                      ]),
                      _createVNode("td", _hoisted_38, [
                        _createVNode("span", _hoisted_39, _toDisplayString(doc.customer), 1)
                      ]),
                      _createVNode("td", _hoisted_40, [
                        _createVNode("div", null, _toDisplayString(_ctx.moment(doc.createDate).format('DD/MM/YYYY')), 1),
                        _createVNode("div", null, _toDisplayString(_ctx.moment(doc.createDate).format('HH:mm')), 1)
                      ]),
                      _createVNode("td", _hoisted_41, _toDisplayString(_ctx.getDateToTitle(doc.issueDate)), 1),
                      _createVNode("td", _hoisted_42, [
                        _createVNode("span", _hoisted_43, _toDisplayString(doc.creator), 1)
                      ]),
                      _createVNode("td", _hoisted_44, [
                        _createVNode("span", {
                          class: "cuted-cell-one-line",
                          style: { color: _ctx.getColorOfAmount(doc) }
                        }, _toDisplayString(_ctx.formatAmount(doc.total)), 5)
                      ]),
                      _createVNode("td", _hoisted_45, [
                        _createVNode("span", _hoisted_46, _toDisplayString(_ctx.formatAmount(doc.amountBeforeVat)), 1)
                      ]),
                      _createVNode("td", _hoisted_47, [
                        _createVNode("span", _hoisted_48, _toDisplayString(_ctx.formatAmount(doc.vat)), 1)
                      ]),
                      _createVNode("td", _hoisted_49, [
                        _createVNode("span", _hoisted_50, _toDisplayString(doc.businessClientName), 1)
                      ]),
                      _createVNode("td", _hoisted_51, [
                        _createVNode("span", _hoisted_52, _toDisplayString(doc.currency), 1)
                      ]),
                      _createVNode("td", _hoisted_53, [
                        _createVNode("i", {
                          class: "icon-f icon-share fs-26 ellipsis-icon",
                          onClick: ($event: any) => (_ctx.shareDocument(doc))
                        }, null, 8, ["onClick"]),
                        _createVNode("i", {
                          class: ["icon-f icon-eye fs-26 ellipsis-icon", { 'blue-color': doc.pdfUrl }],
                          onClick: ($event: any) => (_ctx.showPdf(doc))
                        }, null, 10, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_54, [
          _createVNode("div", _hoisted_55, [
            _createVNode("div", {
              class: "action-item",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.shareDocument(_ctx.selectedDocument)))
            }, [
              _hoisted_56,
              _createVNode("div", null, _toDisplayString(_ctx.$t('documents.share')), 1)
            ]),
            _createVNode("div", {
              class: "action-item",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showPdf(_ctx.selectedDocument)))
            }, [
              _hoisted_57,
              _createVNode("div", null, _toDisplayString(_ctx.$t('documents.preview')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_58, [
            _createVNode("button", {
              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.closeMobileActions())),
              class: "order-modify-button-wrapper back-myorders",
              style: {"position":"relative"},
              type: "button"
            }, [
              _createVNode("div", null, _toDisplayString(_ctx.$t('button.back')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_59, [
          _createVNode("div", _hoisted_60, [
            _createVNode("div", _hoisted_61, [
              _createVNode("div", null, _toDisplayString(_ctx.$t('documents.totalAmount')) + ": ", 1),
              _createVNode("div", null, _toDisplayString(_ctx.formatAmount(_ctx.totalAmount)), 1)
            ]),
            _createVNode("div", _hoisted_62, [
              _createVNode("div", null, _toDisplayString(_ctx.$t('documents.totalAmountBeforeVat')) + ": ", 1),
              _createVNode("div", null, _toDisplayString(_ctx.formatAmount(_ctx.totalAmountBeforeVat)), 1)
            ]),
            _createVNode("div", _hoisted_63, [
              _createVNode("div", null, _toDisplayString(_ctx.$t('documents.totalVat')) + ": ", 1),
              _createVNode("div", null, _toDisplayString(_ctx.formatAmount(_ctx.totalVat)), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})